<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <base-material-card
          color="indigo"
          icon="mdi-content-copy"
          title="Create predefined stock"
          class="px-5 py-3"
        >
          <v-form class="mt-5" @submit.prevent="create">
            <v-text-field
              aria-required="ss"
              color="secondary"
              label="Name"
              v-model="preDefinedStock.name"
              name="name"
              data-vv-as="Name"
              v-validate="validators.name"
              :error="getError('name')"
            />

            <br />

            <h4>Products and quantities</h4>
            <v-container v-for="(productQuantity,i ) in preDefinedStock.productQuantities" :key="i">
              <v-row align="center">
                <v-col cols="7">
                  <v-autocomplete
                    v-model="productQuantity.product.Id"
                    autocomplete="off"
                    label="Products"
                    :items="products"
                    :item-text="text"
                    item-value="id"
                    name="product"
                    data-vv-as="Product"
                    v-validate="validators.product"
                    :error="getError('product')"
                  />
                  <v-text-field
                    v-model.number="productQuantity.quantity"
                    label="Quantity"
                    type="number"
                    name="quantity"
                    data-vv-as="Quantity"
                    v-validate="validators.quantity"
                    :error="getError('quantity')"
                    @keypress="onlyInteger"
                  />
                </v-col>
                <v-col cols="3">
                  <v-icon
                    @click="removeProductQuantity(i)"
                    v-show="i || (!i && preDefinedStock.productQuantities.length > 1)"
                  >mdi-delete</v-icon>
                </v-col>
              </v-row>
            </v-container>
            <v-icon class="mb-5" @click="addProductQuantity()">mdi-plus</v-icon>
            <v-row justify="center">
              <v-card-actions class="pl-0">
                <v-btn color="success" min-width="100" @click="goBack()">Return</v-btn>
              </v-card-actions>
              <v-card-actions class="pl-0">
                <v-btn type="submit" color="success" min-width="100">Submit</v-btn>
              </v-card-actions>
            </v-row>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="snackColor">
        {{ message }}
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import router from "../../../../router";
import {
  getErrorMessageFromException,
  getErrorMessageFromValidation
} from "../../../../helpers/errorHelper";
import { onlyInteger } from "../../../../helpers/inputHelper";
import axios from "../../../../utils/axios";

export default {
  name: "PredefinedStocksCreate",
  data: () => ({
    preDefinedStock: {
      id: 0,
      name: "",
      password: "",
      productQuantities: [],
      totalValue: 0,
      totalInValue: 0
    },
    validators: {
      name: {
        required: true
      },
      product: {
        required: true
      },
      quantity: {
        required: true
      }
    },
    snackbar: false,
    message: "",
    snackColor: "error",
    products: []
  }),

  created() {
    this.init();
  },
  methods: {
    async init() {
      let loader = this.$loading.show();
      try {
        var result = await axios.get("/Product");
        if (result) {
          this.products = result.data;
          this.addProductQuantity();
        } else {
          throw "Unknown error";
        }
      } catch (exception) {
        this.message = exception;
        this.snackbar = true;
      } finally {
        loader.hide();
      }
    },
    async create() {
      this.$validator.validateAll().then(async isValid => {
        if (isValid) {
          let loader = this.$loading.show();
          try {
            var result = await axios.post(
              "/PreDefinedConsignmentStock",
              this.preDefinedStock
            );
            if (result) {
              this.$router.go(-1);
            } else {
              throw "Unknown error";
            }
          } catch (exception) {
            this.message = getErrorMessageFromException(exception);
            this.snackbar = true;
          } finally {
            loader.hide();
          }
        } else {
          this.message = getErrorMessageFromValidation(this.errors.items);
          this.snackbar = true;
        }
      });
    },
    addProductQuantity() {
      this.preDefinedStock.productQuantities.push({
        id: Number,
        product: {
          name: "",
          productDescription: "",
          articleNumber: "",
          id: 0
        },
        quantity: 0
      });
    },
    removeProductQuantity(index) {
      this.preDefinedStock.productQuantities.splice(index, 1);
    },
    getError(fieldName) {
      if (this.errors.first(fieldName) !== undefined) {
        return true;
      }
      return false;
    },
    onlyInteger($event) {
      onlyInteger($event);
    },
    text: item => item.name + " — " + item.articleNumber,
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
</style>